module.exports = __webpack_public_path__ + "img/2.100e77da.jpg";